module.exports = __webpack_public_path__ + "b0c9fdc16f3b86d1d0c98a72dccf8e4b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bb-cream/bb-hero.jpg
 ** module id = 423
 ** module chunks = 0
 **/